import Vue from 'vue'
import Vuex from 'vuex'
import { mutations } from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: JSON.parse(window.localStorage.getItem('currentUser')),
    location: JSON.parse(window.localStorage.getItem('location')),
    showMenu: false,
    cart: JSON.parse(window.localStorage.getItem('cart')) || []
  },
  actions,
  mutations
})
